import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

import RouteWrapper from './route';

import Login from '../pages/Login';
import Dashboard from '../pages/NogleTech/Dashboard';
import Calendario from '../pages/NogleTech/Calendario';
import ComercialDashboard from '../pages/NogleTech/Comercial/Dashboard';
import Pipeline from '../pages/NogleTech/Comercial/Pipeline';
import Contatos from '../pages/NogleTech/Comercial/Contatos';
import Atividades from '../pages/NogleTech/Comercial/Atividades';
import Negocios from '../pages/NogleTech/Comercial/Negocios';
import Anotacoes from '../pages/NogleTech/Comercial/Anotacoes';
import Metas from '../pages/NogleTech/Comercial/Metas';
import Concluidas from '../pages/NogleTech/Comercial/Concluidas';
import Usuarios from '../pages/NogleTech/Usuarios';
import ConsultaMarca from '../pages/NogleTech/ConsultaMarca';
import Controladores from '../pages/NogleTech/Controladores';

import { usePermissions } from '../contexts/AuthPermissionsContext';
import AcessoNegado from '../components/UI/AcessoNegado';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { temPermissao } = usePermissions();
    if (!temPermissao(allowedRoles)) {
        return <AcessoNegado />;
    }
    return children;
};

// Dashboard é exclusiva de admin; não-admin é redirecionado para o Comercial.
const DashboardRoute = () => {
    const { role } = usePermissions();
    if (role && role !== 'admin') {
        return <Navigate to="/comercial" replace />;
    }
    return <Dashboard />;
};

const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />,
    },
    {
        element: <RouteWrapper />,
        children: [
            { path: '/',                       element: <DashboardRoute /> },
            { path: '/calendario',             element: <Calendario /> },
            { path: '/comercial',              element: <ProtectedRoute allowedRoles={['comercial']}><ComercialDashboard /></ProtectedRoute> },
            { path: '/comercial/pipeline',     element: <ProtectedRoute allowedRoles={['comercial']}><Pipeline /></ProtectedRoute> },
            { path: '/comercial/contatos',     element: <ProtectedRoute allowedRoles={['comercial']}><Contatos /></ProtectedRoute> },
            { path: '/comercial/atividades',   element: <ProtectedRoute allowedRoles={['comercial']}><Atividades /></ProtectedRoute> },
            { path: '/comercial/negocios',     element: <ProtectedRoute allowedRoles={['comercial']}><Negocios /></ProtectedRoute> },
            { path: '/comercial/anotacoes',    element: <ProtectedRoute allowedRoles={['comercial']}><Anotacoes /></ProtectedRoute> },
            { path: '/comercial/metas',        element: <ProtectedRoute allowedRoles={['comercial']}><Metas /></ProtectedRoute> },
            { path: '/comercial/concluidas',   element: <ProtectedRoute allowedRoles={['comercial']}><Concluidas /></ProtectedRoute> },
            { path: '/usuarios',               element: <ProtectedRoute allowedRoles={['admin']}><Usuarios /></ProtectedRoute> },
            { path: '/controladores',          element: <ProtectedRoute allowedRoles={['admin']}><Controladores /></ProtectedRoute> },
            { path: '/consulta-marca',         element: <ConsultaMarca /> },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/" replace />,
    },
]);

const RoutesList = () => <RouterProvider router={router} />;

export default RoutesList;
